
import React, { useState, useEffect } from "react";
import axios from "../../../../../../../api/axios";
import "./retailconfig.scss"; // Add your styles here

const Specialconfig = () => {
    const [skuEnabled, setSkuEnabled] = useState(false);
    const [billingEnabled, setBillingEnabled] = useState(false);
    const [billingNotes, setBillingNotes] = useState([""]);
    const [sectionBillingEnabled, setSectionBillingEnabled] = useState(false);

    const business_entity_id = sessionStorage.getItem("configBizEntityId");



    // **1️⃣ Fetch Configuration on Load**
    useEffect(() => {
        const fetchConfig = async () => {
            try {
                const response = await axios.get(`retail/configuration/${business_entity_id}`);
                if (response.status === 200) {
                    const config = response.data;
                    setSkuEnabled(config.sku_enabled);
                    setBillingEnabled(config.billing_enabled);
                    setSectionBillingEnabled(config.section_billing_enabled); 
                    setBillingNotes(config.billing_notes ? JSON.parse(config.billing_notes) : [""]);
                }
            } catch (error) {
                console.error("Error fetching configuration:", error);
            }
        };
        fetchConfig();
    }, [business_entity_id]);

    // **2️⃣ Toggle SKU & Billing**
    const toggleSku = () => setSkuEnabled(!skuEnabled);
    const toggleBilling = () => setBillingEnabled(!billingEnabled);
    const toggleSectionBilling = () => {setSectionBillingEnabled(!sectionBillingEnabled);
    }

    // **3️⃣ Add More Billing Notes**
    const addBillingNote = () => setBillingNotes([...billingNotes, ""]);

    // **4️⃣ Update Billing Notes**
    const handleBillingNoteChange = (index, value) => {
        const updatedNotes = [...billingNotes];
        updatedNotes[index] = value;
        setBillingNotes(updatedNotes);
    };

    // **5️⃣ Save Configuration**
    const handleSaveConfiguration = async () => {
        const configData = {
            business_entity_id: business_entity_id,
            sku_enabled: skuEnabled,
            billing_enabled: billingEnabled,
            section_billing_enabled: sectionBillingEnabled,
            billing_notes: billingEnabled ? billingNotes.filter((note) => note.trim() !== "") : [],
        };

        try {
            const response = await axios.post("retail/configuration", configData);
            if (response.status === 200 || response.status === 201) {
                alert("Configuration saved successfully!");
            }
        } catch (error) {
            console.error("Error saving configuration:", error);
            alert("Failed to save configuration");
        }
    };

    return (
        <>
           
        <div className="config-container">
        <h2>Configuration Settings</h2>

            {/* SKU Configuration */}
            <div className="config-item">
                <span>SKU Configuration</span>
                <label className="toggle-switch">
                    <input type="checkbox" checked={skuEnabled} onChange={toggleSku} />
                    <span className="slider"></span>
                </label>
            </div>

            <div className="config-item">
                <span>Section Billing Configuration</span>
                <label className="toggle-switch">
                    <input type="checkbox" checked={sectionBillingEnabled} onChange={toggleSectionBilling} />
                    <span className="slider"></span>
                </label>
            </div>

            {/* Billing Configuration */}
            <div className="config-item">
                <span>Billing Configuration</span>
                <label className="toggle-switch">
                    <input type="checkbox" checked={billingEnabled} onChange={toggleBilling} />
                    <span className="slider"></span>
                </label>
            </div>

            {/* Billing Notes Section (only if billing is enabled) */}
            {billingEnabled && (
                <div className="billing-notes">
                    <h3>Billing Notes</h3>
                    {billingNotes.map((note, index) => (
                        <input
                            key={index}
                            type="text"
                            value={note}
                            placeholder="Enter billing note"
                            onChange={(e) => handleBillingNoteChange(index, e.target.value)}
                        />
                    ))}
                    <button className="add-note-btn" onClick={addBillingNote}>
                        Add More Line
                    </button>
                </div>
            )}

            {/* Save Configuration Button */}
            <button className="save-btn" onClick={handleSaveConfiguration}>
                Save Configuration
            </button>
        </div>
        </>
    );
};

export default Specialconfig;
